import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getHomeListApi, postHomeDataApi, putHomeDataApi, deletProjectApi, getProjectDataApi } from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    paginatedData: null, // 分页数据
    idData: null, // 单条回显数据
    pageNum: 1, // 初始分页数
}

/* 查询分页数据 */
export const getHomeListAction = createAsyncThunk('HomeSlice/getHomeListAction', async (params, thunkAPI) => {
    try {
        const { data } = await getHomeListApi(params)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 新增项目 */
export const postHomeDataAction = createAsyncThunk(
    'HomeSlice/postHomeDataAction',
    async ({ params, modalAddNew }, thunkAPI) => {
        try {
            if (modalAddNew) {
                delete params.id
                const data = await postHomeDataApi(params)
                return data
            } else {
                const data = await putHomeDataApi(params)
                return data
            }
        } catch (error) {
            thunkAPI.dispatch(BoundarySlice.actions.addError(error))
        }
    }
)

/* 删除项目 */
export const deletProjectAction = createAsyncThunk('HomeSlice/deletProjectAction', async (id, thunkAPI) => {
    try {
        const { data } = await deletProjectApi(id)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 通过 id 获取项目 */
export const getProjectDataAction = createAsyncThunk('HomeSlice/getProjectDataAction', async (id, thunkAPI) => {
    try {
        const { data } = await getProjectDataApi(id)
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

export const HomeSlice = createSlice({
    name: 'HomeSlice',
    initialState,
    reducers: {
        changepPageNum: (state, action) => {
            state.pageNum = action.payload
        },
    },
    extraReducers: {
        /* 分页数据 */
        [getHomeListAction.fulfilled.type]: (state, action) => {
            state.paginatedData = action.payload
        },

        /* 通过 ID 获取项目数据 */
        [getProjectDataAction.fulfilled.type]: (state, action) => {
            state.idData = action.payload
        },
    },
})
